import { DefaultModelProperty, LabelValue } from '../standard'
import MediaDescription from './media-description-model'
import mediaDescriptionProperties from './mediaDescription-properties'
import { MediaDescriptionProperties } from './mediaDescription-property-definitions'

export async function OnEvents(
  eventType: string,
  form: MediaDescription,
  property: MediaDescriptionProperties,
): Promise<MediaDescription> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(
  page: any,
  property: MediaDescriptionProperties,
): boolean {
  switch (property) {
    case MediaDescriptionProperties.Name:
      return (() => {
        function _viewDisabled(): any {
          return !!page
        }

        return _viewDisabled()
      })()
      break
    case MediaDescriptionProperties.Description:
      return (() => {
        function _viewDisabled(): any {
          return !!page
        }

        return _viewDisabled()
      })()
      break
    case 'nameDefault':
      return (() => {
        function _viewDisabled(): any {
          return !!page
        }

        return _viewDisabled()
      })()
      break
    case 'descriptionDefault':
      return (() => {
        function _viewDisabled(): any {
          return !!page
        }

        return _viewDisabled()
      })()
      break
    default:
      return false
  }
}

export function IsVisible(property: MediaDescriptionProperties): boolean {
  switch (property) {
    case MediaDescriptionProperties.Name:
      return false
    case MediaDescriptionProperties.Description:
      return false
    case MediaDescriptionProperties.Owner:
      return false
    case MediaDescriptionProperties.Id:
      return false
    case MediaDescriptionProperties.Created:
      return false
    case MediaDescriptionProperties.Updated:
      return false
    case MediaDescriptionProperties.Deleted:
      return false
    case MediaDescriptionProperties.Version:
      return false
    default:
      return true
  }
}
async function change(
  property: MediaDescriptionProperties,
  value: MediaDescription,
): Promise<MediaDescription> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<MediaDescriptionProperties>[] {
  return mediaDescriptionProperties as DefaultModelProperty<MediaDescriptionProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<MediaDescriptionProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<MediaDescriptionProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<MediaDescriptionProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: MediaDescriptionProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: MediaDescriptionProperties): boolean {
  switch (property) {
    case MediaDescriptionProperties.Name:
      return false
    case MediaDescriptionProperties.Description:
      return false
    case MediaDescriptionProperties.Owner:
      return false
    case MediaDescriptionProperties.Id:
      return false
    case MediaDescriptionProperties.Created:
      return false
    case MediaDescriptionProperties.Updated:
      return false
    case MediaDescriptionProperties.Deleted:
      return false
    case MediaDescriptionProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<MediaDescriptionProperties>[],
): DefaultModelProperty<MediaDescriptionProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<MediaDescriptionProperties>) => {
      switch (modelProperty.name) {
        default:
          break
      }
      return modelProperty
    },
  )
}
